<ngx-spinner bdColor="rgba(0, 0, 0, 0.5)" [fullScreen]="true">
  <div class="custom-spinner">
    <img
      src="/assets/icons/spinner-otic-2018.png"
      alt="Logo Empresa"
      class="spinner-logo"
    />
  </div>
</ngx-spinner> 
<div class="container-fluid d-flex align-items-center justify-content-center py-5 custom-container">
  <ng-container *ngIf="!isMobileView">
    <div class="usuario-otic-card card shadow p-5">
      <div class="row">
        <div class="col-12">
          <img src="../../../../assets/img/logo_sofofa.svg" alt="logo sofofa" width="90px" height="37px">
        </div>
        <div class="col-12 my-5">
          <div class="usuario-otic-barra-gradiente ps-3">
            <p class="usuario-otic-text mb-0">Ingrese a su cuenta</p>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-12 px-5">
              <button (click)="login()" class="btn usuario-otic-btn">
                <img src="../../../../assets/img/login_google.svg" alt="G+ de Google" class="me-2">
                Ingresar con Google
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #mobileVersion>
    <div class="h-100">
      <div class="row">
        <div class="col-12 d-flex justify-content-center my-5">
          <img src="../../../../assets/img/logo_sofofa.svg" alt="logo sofofa" width="200px">
        </div>
        <div class="col-12 ps-4 my-5">
          <div class="usuario-otic-barra-gradiente ps-3">
            <p class="usuario-otic-title mb-0">Usuario OTIC</p>
            <p class="usuario-otic-text mb-0">Ingrese a su cuenta</p>
          </div>
        </div>
        <div class="col-12 my-5">
          <div class="row">
            <div class="col-12 d-flex justify-content-center">
              <div class="">
                <button (click)="login()" class="btn usuario-otic-btn px-5 py-3">
                  <img src="../../../../assets/img/login_google.svg" alt="G+ de Google" class="me-2">
                  Ingresar con Google
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
